import React from 'react'
import numeral from 'numeral'

const Numeral = (props) => {
  if (props.value > 999999) {
    var formatted = numeral(props.value).format('0,0.0a')
  } else if (props.value > 999) {
    var formatted = numeral(props.value).format('0,0a')
  } else {
    var formatted = numeral(props.value).format('0,0')
  }
  return (
    <span>${formatted}</span>
  )
}

export default Numeral




// WEBPACK FOOTER //
// ./src/components/Numeral/index.js